import BrainInboxesAPI from 'dashboard/api/brain/inboxes';
import { createStore, generateMutationTypes } from '../storeFactory';

const mutationTypes = generateMutationTypes('BrainInbox');

export default createStore({
  name: 'BrainInbox',
  API: BrainInboxesAPI,
  actions: () => ({
    async delete({ commit }, { assistantId, inboxId }) {
      commit(mutationTypes.SET_UI_FLAG, { deletingItem: true });
      try {
        await BrainInboxesAPI.delete({ assistantId, inboxId });
        commit(mutationTypes.DELETE, inboxId);
        return inboxId;
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { deletingItem: false });
      }
    },
  }),
});
